<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="false" :dateRangeMenu="false" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <div v-show="step === -1">
            <md-empty-state
              md-icon="verified"
              :md-label="$lang.titles.firmware_not_available"
              :md-description="$lang.messages.upgrade_not_available"
            ></md-empty-state>
          </div>

          <div v-show="step === 0">
            <md-empty-state
              class="md-primary"
              md-icon="verified"
              :md-label="$lang.titles.firmware_up_to_date"
              :md-description="$lang.messages.current_firmware_version + ' ' + currentFWVersion"
            ></md-empty-state>
          </div>

          <div v-show="step === 1">
            <md-empty-state
              md-icon="update"
              :md-label="$lang.titles.firmware_upgrade_available"
              :md-description="$lang.messages.available_firmware_version + ' ' + availableFWVersion"
            >
              <md-button
                class="md-success"
                @click="startUpgrade"
                v-if="deviceStatus()"
              >{{$lang.keys.upgrade}}</md-button>
              <md-button class="md-danger" v-else disabled>{{$lang.keys.upgrade_offline}}</md-button>
            </md-empty-state>
          </div>

          <div class="text-center" v-show="step === 2">
            <vue-ellipse-progress
              :progress="progress"
              color="#4caf50"
              empty-color="#c8e6c9"
              :size="200"
              :thickness="5"
              :empty-thickness="3"
              animation="rs 100 100"
              fontSize="1.5rem"
              font-color="#272727"
              dot="5"
              :determinate="true"
            >
              <span slot="legend-value">%</span>
              <p v-show="upgradingDesction" slot="legend-caption">{{upgradingDesction}}</p>
            </vue-ellipse-progress>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import axios from "axios";
import snackBar from "@/components/SnackBar";
import { getSelectedDeviceToken, getUserToken } from "@/storage/memoryStorage";
import graphToolBar from "@/components/GraphToolBar";

export default {
  components: {
    snackBar,
    graphToolBar
  },

  data() {
    return {
      progress: 0,
      upgradingDesction: "",
      selectedDevice: null,
      availableFWVersion: "",
      currentFWVersion: "",
      step: -1,
      WSUpgrading: false
    };
  },

  computed: {
    isConnected() {
      return this.$store.getters.isConnected;
    },
    WSmessage() {
      return this.$store.getters.getPayload;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },

  watch: {
    isConnected: function(newStatus, oldStatus) {
      if (newStatus && !oldStatus) {
        if (this.selectedDevice) {
          this.upgradeSubscribe(this.selectedDevice.mac, true);
        }
      }
    },

    WSmessage: function(payload, oldPayload) {
      if (payload.topic == "Upgrade") {
        if (payload.data.code == 1) {
          this.WSUpgrading = true;
          this.step = 2;
        } else {
          this.WSUpgrading = false;
          if (payload.data.reason) {
            if (payload.data.reason.code === 503) {
              this.$refs.snackbar.notify(this.$lang.messages.upgrade_failed);
              this.step = 1;
            } else if (payload.data.reason.code === 540) {
              this.$refs.snackbar.notify(this.$lang.messages.upgrade_timeout);
              this.getUpgradeStatus();
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
              this.getUpgradeStatus();
            }
          }
        }
        if (payload.data.progress) {
          this.progress = payload.data.progress.complet_percent;
        }

        if (payload.data.step) {
          if (payload.data.step == "START") {
            this.upgradingDesction = this.$lang.messages.starting_upgrade;
          }
          if (payload.data.step == "DOWNLOADING") {
            this.upgradingDesction = this.$lang.messages.upgrading;
          }
          if (payload.data.step == "REBOOT_WAIT") {
            this.upgradingDesction = this.$lang.messages.rebooting;
          }
          if (payload.data.step == "SUCCESS_END") {
            this.step = 0;
          }
        }
      }
    }
  },

  created() {
    //this.$store.commit("setLoading", true);
  },

  methods: {
    onPanelSelect(selected) {
      if (this.isConnected) {
        if (this.selectedDevice) {
          this.upgradeSubscribe(this.selectedDevice.mac, false);
        }
        this.upgradeSubscribe(selected.device.mac, true);
      }
      this.WSUpgrading = false;
      this.selectedDevice = selected.device;
      this.getUpgradeStatus();
    },

    deviceStatus() {
      try {
        const deviceListIndex = this.deviceList.findIndex(
          e => e.mac == this.selectedDevice.mac
        );
        if (this.deviceList[deviceListIndex].status === "ONLINE") {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    getUpgradeStatus() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/devices/upgrade",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          user_token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          if (!this.WSUpgrading) {
            if (response.data.key === "NEW_FW_AVAILABLE") {
              this.availableFWVersion = response.data.data.available_fw.version;
              this.step = 1;
            } else if (response.data.key === "UP_TO_DATE") {
              this.currentFWVersion = response.data.data.current_fw.version;
              this.step = 0;
            }
          }

          setTimeout(() => {
            this.$store.commit("setLoading", false);
          }, 100);
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code === 636) {
              this.step = -1;
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
              this.step = 0;
            }
          }
        });
    },

    startUpgrade() {
      this.progress = 0;

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/devices/upgrade",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          user_token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          //this.step = 0;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code === 503) {
              this.$refs.snackbar.notify(this.$lang.messages.upgrade_failed);
              this.step = 1;
            } else if (error.response.data.code === 529) {
              this.$refs.snackbar.notify(
                this.$lang.messages.device_not_responding_or_offline
              );
              this.step = 1;
            } else if (error.response.data.code === 540) {
              this.$refs.snackbar.notify(this.$lang.messages.upgrade_timeout);
              this.getUpgradeStatus();
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
              this.getUpgradeStatus();
            }
          }
        });
    },

    upgradeSubscribe(deviceMAC, subscribe) {
      const subMessage = {
        deviceToken: getSelectedDeviceToken(deviceMAC),
        upgrade: subscribe
      };
      this.$socket.send(JSON.stringify(subMessage));
    }
  },

  beforeDestroy() {
    try {
      this.upgradeSubscribe(this.selectedDevice.mac, false);
    } catch {}
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>